module.exports = __webpack_public_path__ + "static/img/hammer.5d8487a4.png";